import * as MesaLib from '@acre-rewards/lib'
import { providePaymentMethods } from '@/src/experiences/card-payments/providePaymentMethods'

export const withPaymentMethodsForCashForMortgage = providePaymentMethods({
  products: [MesaLib.Plaid.Products.enum.Transfer, MesaLib.Plaid.Products.enum.Auth],
  // @TODO: maybe we want to disable this, my guess is this is going to change to platform?
  shouldLinkToHighnote: true,
  shouldImportTransactions: false,
  allowNonCardMember: true,
})
